import BaseComponent from "../BaseComponent";
import Button from "../Button";
import Dropdown from "../Dropdown";
import { getTextToSpeechVoiceOptions } from "../../utilities";

export default class LanguageSubCon extends BaseComponent {
    constructor(props) {
        super(props);

        const {
            language,
            ttsFallBackVoice,
            voice = '',
            varIdx
        } = props.data ?? {};
        this.state = {
            language,
            voice,
            ttsFallBackVoice,
            ttsFallBackVoices: getTextToSpeechVoiceOptions(language),
            varIdx: varIdx ?? -1
        };
    }

    /**
     * Set config proxy; catches own input value updates and update its data model before saving to list.
     * @param {string} key
     * @param {string} value
     */
    setConfig(key, value) {
        this.setState({ [key]: value });
        if (key === "language") {
            this.setState({ ttsFallBackVoices: getTextToSpeechVoiceOptions(value) });
            this.setState({ ttsFallBackVoice: '' });
        }
    }

    render() {
        const includeVoice = window.apm.isVoiceChannelEnabled();
        const languages = window.apm.knowledgeBase.getLanguages();
        const voices = window.apm.knowledgeBase.getVoices();
        const {
            language,
            ttsFallBackVoice,
            ttsFallBackVoices,
            varIdx,
            voice
        } = this.state;
        const isDefaultLanguage = varIdx === 0;
        const isNewLanguage = varIdx === -1;
        const languageIdx = languages.findIndex((element) => {
            return element.value === language;
        });
        const voiceIdx = voices.findIndex((element) => element.value === voice);
        const ttsVoiceSelection = ttsFallBackVoices.findIndex((element) => {
            return element.value === ttsFallBackVoice;
        });

        return (
            <div>
                <Dropdown
                    context={this}
                    label="Language"
                    optionName={this.getPropLabel("select_language")}
                    options={window.apm.knowledgeBase.getLanguages()}
                    readOnly={isDefaultLanguage}
                    selection={languageIdx}
                    valKey="language"
                    wide
                />
                {(!includeVoice) ? null : (
                    <>
                        <Dropdown
                            context={this}
                            label="Voice Talent"
                            optionName={this.getPropLabel("select_voice")}
                            options={window.apm.knowledgeBase.getVoices()}
                            selection={voiceIdx}
                            valKey="voice"
                            wide
                        />
                        <Dropdown
                            context={this}
                            label="TTS Voice"
                            optionName={this.getPropLabel("select_tts_voice")}
                            options={ttsFallBackVoices}
                            removable
                            selection={ttsVoiceSelection}
                            valKey="ttsFallBackVoice"
                            wide
                        />
                    </>
                )}
                <div className="box flex-end no-pad">
                    {(isNewLanguage || isDefaultLanguage) ? null : (
                        <Button
                            icon="icon-trash"
                            tint="warning"
                            callback={() => {
                                this.props.context.remove(varIdx);
                                this.props.domContext.removeSubmenu();
                            }}
                        />
                    )}
                    <Button
                        label={this.getPropLabel((isNewLanguage) ? "add" : "save")}
                        wide={true}
                        callback={() => {
                            const languageData = {
                                language,
                                voice,
                                ttsFallBackVoice
                            };
                            const isVoiceValid = (
                                !includeVoice
                                || ttsFallBackVoice
                                || voice
                            );

                            // Add current data model to item list.
                            if (
                                !language
                                || !isVoiceValid
                            ) {
                                window.apm.notification.post(
                                    "error",
                                    "Make sure to select a Language and either a Voice Talent or a TTS Voice."
                                );
                                return;
                            } else if (isNewLanguage) {
                                this.props.context.add(languageData);
                            } else {
                                this.props.context.update(languageData, varIdx);
                            }

                            // Update settings props.
                            window.apm.reactDOMComponents.render({
                                name: 'SettingWidget',
                                props: {
                                    serialized: window.apm.serialized
                                },
                                $el: $('#settings')
                            });
                            window.apm.postEventToCurrentView({ target: "request-refresh" });
                            this.forceUpdate();
                            this.props.domContext.removeSubmenu();
                        }}
                    />
                </div>
            </div>
        );
    }
}
